//GET_SEARCHBAR_DATA
export const GET_SEARCHBAR_DATA_REQUEST = "GET_SEARCHBAR_DATA_REQUEST";
export const GET_SEARCHBAR_DATA_SUCCESS = "GET_SEARCHBAR_DATA_SUCCESS";
export const GET_SEARCHBAR_DATA_FAIL = "GET_SEARCHBAR_DATA_FAIL";
